import {styled} from '../../styled-components';

export const DialogContainer = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    height: 100%;
    pointer-events: none;
`;

DialogContainer.displayName = 'DialogContainer';
